export type TimelineCard = {
  title: string
  quantityText: string
  note?: string
}

export type TimelineEvent = {
  id: string
  when: string
  label: string
  badge?: string
  cards: TimelineCard[]
}

export type ItemDetail = {
  id: string
  name: string
  lpoCode: string
  shelf: string
  uppStatus: "Active" | "Inactive"
  overview: {
    itemCode: string
    manufacturer: string
    storageCondition: string
    category: string
    registrationNumber: string
    scientificName: string
    activeIngredient: string
    dosageForm: string
    administration: string
    pharmaClass: string
    clinicalNotes: string
  }
  gtins: Array<{ code: string; description: string }>
  metricsCount: number
  stocksCount: number
  timeline: TimelineEvent[]
}

export const sampleItem: ItemDetail = {
  id: "inv-1",
  name: "Ibuprofen 200mg",
  lpoCode: "LPO12345678",
  shelf: "Shelf Rack -1",
  uppStatus: "Active",
  overview: {
    itemCode: "IBU-200-001",
    manufacturer: "Pfizer Inc.",
    storageCondition: "Room Temperature (15-25°C)",
    category: "Pain Relief",
    registrationNumber: "REG-2023-08-12345",
    scientificName: "Ibuprofen",
    activeIngredient: "Ibuprofen 200mg",
    dosageForm: "Tablet",
    administration: "Oral",
    pharmaClass: "NSAID",
    clinicalNotes:
      "Patient reported symptoms for 3 days. Started with sore throat, now has fever.",
  },
  gtins: [
    { code: "GTIN-001", description: "Primary pack" },
    { code: "GTIN-002", description: "Secondary pack" },
  ],
  metricsCount: 1,
  stocksCount: 1,
  timeline: [
    {
      id: "ev-thisweek",
      when: "This week",
      label: "Stock Received +500 units",
      badge: "Stock Requisitioned",
      cards: [
        { title: "Transfer Completed", quantityText: "-100 units" },
        { title: "Stock Return", quantityText: "+25 units" },
      ],
    },
    {
      id: "ev-april",
      when: "April",
      label: "Created Order",
      badge: "Inventory Update",
      cards: [
        { title: "Stock Received", quantityText: "+500 units" },
        { title: "Stock Requisitioned", quantityText: "-100 units" },
        { title: "Transfer Completed", quantityText: "-50 units" },
      ],
    },
  ],
}

